import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import { AnalyticsService } from "@/services/analytics.js";
import { APP_VERSION, HOTJAR_SITE_ID, SEGMENT_KEY, SENTRY_DNS } from "@/config-global.jsx";
import * as Sentry from "@sentry/react";
import Hotjar from '@hotjar/browser';

if (SEGMENT_KEY) {
    AnalyticsService.init()
    try {
        const urlParams = new URLSearchParams(window.location.search);
        const btn = urlParams.get('btn')
        AnalyticsService.track('app-loaded', { btn })
    } catch (e) {
        console.log(e)
    }

}

if (HOTJAR_SITE_ID) {
    Hotjar.init(HOTJAR_SITE_ID, 6);
}

if (SENTRY_DNS) {
    console.log('Sentry init')
    // https://spring-prod-447013.uc.r.appspot.com
    Sentry.init({
        dsn: SENTRY_DNS,
        integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false, })],
        // Performance Monitoring
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ["localhost", /^https:\/\/spring-prod-447013\.uc\.r\.appspot\.com/],
        // Session Replay
        replaysSessionSampleRate: 0.3, // This sets the sample rate at 30%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
}

window.tellMeVersion = () => {
    console.log(APP_VERSION)
}


ReactDOM.createRoot(document.getElementById('root')).render(<App />)
